import { debounce } from 'lodash';
import { useLayoutEffect, useState } from 'react';

export type UseIsMobileReturn = {
  isMobile: boolean;
  isMobileLoading: boolean;
};

export const useIsMobile = (breakpoint = 768): UseIsMobileReturn => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMobileLoading, setIsMobileLoading] = useState(true);

  useLayoutEffect(() => {
    const updateSize = (): void => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // Set the initial state
    updateSize();
    setIsMobileLoading(false);

    const debouncedUpdateSize = debounce(updateSize, 200);

    window.addEventListener('resize', debouncedUpdateSize);

    return (): void => {
      window.removeEventListener('resize', debouncedUpdateSize);
      debouncedUpdateSize.cancel?.();
    };
  }, [breakpoint]);

  return { isMobile, isMobileLoading };
};
